<template>
  <div class="page-full" v-show="loginVisible">
    <div class="image-login">
      <img src="@/assets/logo-lifeapps.png" alt="" />
    </div>
    <Card width="400px" shadown :loading="isLoading">
      <v-list-item-content>
        <form @submit.prevent="onVerifySSO" v-if="!emailVerified">
          <FormField
            v-model="usuario"
            label="Email"
            placeholder="Digite seu email"
            :validation="$v.usuario"
          ></FormField>
          <FormButton
            submit
            type="submissao"
            full
            text="Continuar"
            @click="onVerifySSO"
          />
        </form>
        <form @submit.prevent="onSubmit" v-if="emailVerified && !usesSSO">
          <div class="email-display">
            <p>{{ usuario }}</p>
            <span @click="resetLogin" class="change-email">Alterar</span>
          </div>
          <div class="company-name" v-if="companyName">
            <p>{{ companyName }}</p>
          </div>
          <FormPassword
            v-model="senha"
            type="password"
            placeholder="Senha"
            label="Senha"
            :validation="$v.senha"
          >
          </FormPassword>
          <FormButton
            submit
            type="submissao"
            full
            text="Entrar"
            @click="onSubmit"
          />
        </form>
        <div v-if="emailVerified && usesSSO" class="sso-message">
          <div class="sso-loading">
            <div class="spinner"></div>
            <p><strong>Redirecionando para login SSO...</strong></p>
            <p class="company-sso">{{ companyName }}</p>
          </div>
          <FormButton
            type="secondary"
            full
            text="Cancelar"
            @click="resetLogin"
          />
        </div>
      </v-list-item-content>
    </Card>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { AUTH_LOGIN } from "../store/actions/auth";
import { mapGetters } from "vuex";
import FormField from "@/components/form/FormField";
import FormPassword from "@/components/form/FormPassword";
import Card from "@/components/Card";
import FormButton from "@/components/form/FormButton";
import RSSParser from "rss-parser";
import * as _ from "lodash";
import Api from "../service/api-web";

export default {
  name: "Login",
  mixins: [validationMixin],
  components: { FormField, FormPassword, Card, FormButton },
  validations: {
    senha: { required },
    usuario: { required }
  },
  data: () => ({
    senha: "",
    usuario: "",
    isLoading: false,
    loginVisible: true,
    blogPosts: null,
    emailVerified: false,
    usesSSO: false,
    companyName: "",
    ssoRedirectTimeout: null
  }),
  computed: {
    ...mapGetters(["isAuthenticated"]),
    usuarioErrors() {
      const errors = [];
      if (!this.$v.usuario.$dirty) return errors;
      !this.$v.usuario.required && errors.push("O email é obrigatório");
      return errors;
    },
    senhaErrors() {
      const errors = [];
      if (!this.$v.senha.$dirty) return errors;
      !this.$v.senha.required && errors.push("A senha é obrigatória");
      return errors;
    }
  },
  created() {
    if (this.isAuthenticated) {
      this.$router.push("/");
    } else {
      this.loadFeed();
    }
  },

  beforeDestroy() {
    if (this.ssoRedirectTimeout) {
      clearTimeout(this.ssoRedirectTimeout);
    }
  },
  methods: {
    async loadFeed() {
      try {
        const parser = new RSSParser();
        const feed = await parser.parseURL(
          "https://lifeapps.com.br/conteudo/blog/feed/"
        );
        const posts = feed.items || [];
        const index = Math.floor(Math.random() * (posts.length - 1 + 1));
        const post = _.get(posts, index);
        this.blogPosts = {
          title: post.title,
          link: post.link,
          description:
            post.contentSnippet.length > 100
              ? post.contentSnippet.substr(0, 97) + "..."
              : post.contentSnippet
        };
      } catch (err) {
        // console.log(err)
      }
    },
    resetLogin() {
      if (this.ssoRedirectTimeout) {
        clearTimeout(this.ssoRedirectTimeout);
        this.ssoRedirectTimeout = null;
      }
      this.emailVerified = false;
      this.usesSSO = false;
      this.companyName = "";
      this.senha = "";
    },
    async onVerifySSO() {
      this.$v.usuario.$touch();
      if (this.$v.usuario.$invalid) return;
      this.isLoading = true;
      try {
        const response = await Api.api.post("/verify-sso", {
          email: this.usuario
        });
        const { companyName, usesSSO } = response.data;
        this.$store.commit("SET_SSO_INFO", { companyName, usesSSO });
        this.companyName = companyName;
        this.usesSSO = usesSSO;
        this.emailVerified = true;

        if (usesSSO) {
          this.initiateSSO();
        }
      } catch (error) {
        this.$vueOnToast.pop(
          "error",
          "Erro ao verificar email. Por favor, tente novamente."
        );
      } finally {
        this.isLoading = false;
      }
    },
    initiateSSO() {
      this.ssoRedirectTimeout = setTimeout(() => {
        this.redirectToKeycloak();
      }, 2000);
    },
    redirectToKeycloak() {
      import("@/config/keycloak").then(({ KeycloakUtils }) => {
        KeycloakUtils.redirectToKeycloak(this.usuario);
      });
    },
    generateState() {
      return (
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Date.now().toString(36)
      );
    },
    onSubmit() {
      this.$v.senha.$touch();
      if (this.$v.senha.$invalid) return;
      this.isLoading = true;
      this.$store
        .dispatch(AUTH_LOGIN, {
          username: this.usuario,
          password: this.senha
        })
        .then(resp => {
          this.loginVisible = false;
          this.$vueOnToast.pop("success", "Login efetuado com sucesso");
          if (resp.funcao == "adm") {
            this.redirectUser("/admin");
          } else {
            this.redirectUser("/fornecedor/inicio");
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    redirectUser(path) {
      setTimeout(() => {
        this.$router.push(path);
        this.isLoading = false;
      }, 300);
    }
  }
};
</script>

<style lang="scss">
.page-full {
  min-height: calc(100vh - 40px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .image-login {
    width: 250px;
    justify-content: center;
    align-items: center;
    display: flex;
    margin: 10px;
    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }
  }
  .rss-footer {
    width: 400px;
    margin-top: 80px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    color: #558ed0;
    text-decoration: none;
    .title-rss {
      font-size: 15px;
      margin-bottom: 0px;
    }
    p {
      font-size: 12px;
      margin-bottom: 5px;
    }
  }
  .aux-link {
    font-size: 12px;
    margin-bottom: 5px;
    margin-top: 15px;
    text-decoration: none;
  }

  .email-display {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background-color: rgba(245, 245, 245, 0.1);
    border-radius: 4px;
    margin-bottom: 15px;

    p {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
    }

    .change-email {
      color: #558ed0;
      cursor: pointer;
      font-size: 12px;
      text-decoration: underline;
    }
  }

  .company-name {
    margin-bottom: 15px;
    text-align: center;

    p {
      margin: 0;
      font-weight: bold;
      color: #555;
    }
  }

  .sso-message {
    text-align: center;
    padding: 20px 0;

    .sso-loading {
      margin-bottom: 20px;

      .spinner {
        border: 3px solid #f3f3f3;
        border-top: 3px solid #558ed0;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        animation: spin 1s linear infinite;
        margin: 0 auto 15px;
      }
    }

    p {
      margin-bottom: 8px;
      color: #555;
    }

    .company-sso {
      color: #558ed0;
      font-weight: 600;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
